import { render, staticRenderFns } from "./site-setup-button-bar.component.vue?vue&type=template&id=85031bc4"
import script from "./site-setup-button-bar.component.ts?vue&type=script&lang=ts&external"
export * from "./site-setup-button-bar.component.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/foex-3r/foex-3r-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('85031bc4')) {
      api.createRecord('85031bc4', component.options)
    } else {
      api.reload('85031bc4', component.options)
    }
    module.hot.accept("./site-setup-button-bar.component.vue?vue&type=template&id=85031bc4", function () {
      api.rerender('85031bc4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/client/site-setup/site-setup-button-bar/site-setup-button-bar.component.vue"
export default component.exports